export default "__VITE_ASSET__fw$thcbh__"